var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import backdropBlur from "./mixins/backdropBlur";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  inset: 0px;\n  z-index: 35;\n  pointer-events: none;\n  outline: none;\n"], ["\n  position: fixed;\n  inset: 0px;\n  z-index: 35;\n  pointer-events: none;\n  outline: none;\n"])));
var Backdrop = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  inset: 0px;\n  pointer-events: all;\n  background-color: rgba(0, 0, 0, 0.3);\n  ", ";\n}\n"], ["\n  position: absolute;\n  inset: 0px;\n  pointer-events: all;\n  background-color: rgba(0, 0, 0, 0.3);\n  ", ";\n}\n"])), backdropBlur);
var BackdropContainer = function (_a) {
    var children = _a.children, backdropProps = _a.backdropProps;
    return (React.createElement(Container, { "data-testid": "layer-backdropContainer" },
        React.createElement(Backdrop, __assign({ "data-testid": "layer-backdrop" }, backdropProps)),
        children));
};
export default BackdropContainer;
var templateObject_1, templateObject_2;
